import { config } from '~app/config';

import { ResponseSuccess } from '@breezeventures/scp-client';
import { makeRequest } from '@breezeventures/web-lib-ph-request/make-request';
import {
  skipToken,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';

import { agreementKeys } from './agreement-keys';

type PartnerAgreementPayload = {
  agreementUrl: string;
};

type GetPartnerAgreementRequest = {
  applicationId: string | undefined;
};

export const usePartnerAgreement = (
  data: GetPartnerAgreementRequest,
  options?: Omit<UseQueryOptions<string>, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: agreementKeys.url(data.applicationId),
    queryFn: data.applicationId
      ? async () => {
          const { agreementUrl } = (
            await makeRequest<ResponseSuccess<PartnerAgreementPayload>>({
              url: `${config.apiHost}/merchant-origination/api/v1/public/partner/applications/agreement/get`,
              credentials: 'include',
              payload: { applicationId: data.applicationId },
            })
          ).payload;

          return agreementUrl;
        }
      : skipToken,
    ...options,
  });
};
